import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Button, Card, Container, Row } from "react-bootstrap";
import { InfraAPI } from "../../components/apis/index";
import ErrorMessage from "../../components/common/ErrorMessage";
import { useisLoading } from "../../hook/useisLoading";
import Loading from "../../components/common/Loading";

export const Postman = ( {appInstance_name }, context ) => {

    const [postmanJson, setPostmanJson] = useState(null)
    const [alertVisible, setAlertVisible] = useState(false)  
    const { isLoading, hideSpinner } = useisLoading(true);

    let infraApi;

    useEffect(() => {
        // setpostmanJson("eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkoxeXlaTWhZY3FobGd6czBWNUZwXyJ9.eyJpc3MiOiJodHRwczovL3NueHIudXMuYXV0aDAuY29tLyIsInN1YiI6Imdvb2dsZS1vYXV0aDJ8MTE1NjAzNDgwNDc0OTI5OTI0MjkwIiwiYXVkIjpbImh0dHBzOi8vc254ci51cy5hdXRoMC5jb20vYXBpL3YyLyIsImh0dHBzOi8vc254ci51cy5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNjM0MDA1MzMzLCJleHAiOjE2MzQwOTE3MzMsImF6cCI6IjFmS0hudVk4c0NxdERxYW00dk1qMjZ1QVJrNGNNTTlXIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSJ9.XpoolREkdipucaEufoaWOgGNYEYqnFtMMOX8OrlWJMSphvYyxwC0XCLkKsiBOFsIcQqGzxv5xG3v0fieUl03OkZK88zcyRkYiGa_H2AQlHQ8ex93Mlzw99h5-LQ4buYpU6AI6qQ6ncod6JEzJNjYCIrV9PrtJgzbD5bQ2s6uQ-AJBPxYFO9myt-lydRRAOZtPzGgGmJmaHEv1tF_NuB_VGC6-9xlreqnB6iXYpFm5X4kV3W2HT-A2o3DkfEvE9ELBj96rGdd-iIm0i6KTApdn7jaFaqbpF8GozPJw5q_3awRLTUx-YaFCloVFsTAVDmM-knOR-qwOm-u8H443XFckg");
        
        if (!postmanJson) {
            infraApi = new InfraAPI();
            infraApi.getSwagger(appInstance_name)
            .then(data => {
                console.log("json", data);
                setPostmanJson(JSON.stringify(data));
            })
            .catch(err => {
                setAlertVisible(true);
            })
        }
    }, []);


    const handleCopy = () => {
        
        navigator.clipboard.writeText(postmanJson)
        .then(  ok => {
                    window.close();
                },
                error => {
                    alert("Error on copying to clipboard.")
                }
        )
    }

  // const downloadJson = () => {
  //   let filename = "postman-collection.json";
  //   let element = document.createElement('a');
  //   element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  //   element.setAttribute('download', filename);

  //   element.style.display = 'none';
  //   document.body.appendChild(element);

  //   element.click();

  //   document.body.removeChild(element);

  // }

    const dismiss = () => {
        setAlertVisible(false);
    };

    if (isLoading){
        return <Loading/>
    } else {
        return (
            <>  
                {alertVisible ?
                    (
                        <ErrorMessage message="Something went wrong!"/>
                    )
                :
                    (    
                        <Container>
                            <br />
                            <Row>
                            <Card>
                                <Card.Body>
                                {/* <Card.Title>Use the Copy button to import raw text in Postman, otherwise download and import file</Card.Title> */}
                                <Card.Text>
                                    {` ${postmanJson && postmanJson.substring(0, postmanJson.length < 1000 ? postmanJson.length : 1000)} ...`}
                                </Card.Text>
                                <Button variant="primary" onClick={handleCopy}>Copy to Clipboard and Close</Button>
                                <a 
                                    target={`${appInstance_name}-postman-download`}
                                    download={ "postman-collection.json" }
                                    href={ `data:text/plain;charset=utf-8,${encodeURIComponent(postmanJson)}` }
                                >
                                    <Button variant="secondary" onClick={handleCopy}>Download</Button>
                                </a>
                                </Card.Body>
                            </Card>
                            </Row>
                        </Container>
                    )
                }
            </>
        )
    }
};



Postman.contextTypes = {
    t: PropTypes.func.isRequired
}

export default Postman;